/**
 * Route paths for the miscellaneous admin module.
 * Single source of truth — reuse these instead of hard-coding `/notification`, `/plans` and `/print` strings.
 */
export const ADMIN_ROUTES = {
  notification: "/notification",
  plans: "/plans",
  print: "/print",
} as const;
